import { useQuery } from '@tanstack/react-query';
import { overviewApi } from '../api/overview';

export function useOverviewSummary() {
  return useQuery({
    queryKey: ['overview', 'summary'],
    queryFn: overviewApi.getSummary,
    refetchInterval: 30_000,
    staleTime: 15_000,
  });
}

export function useMetricsHistory(hours = 24 * 7) {
  return useQuery({
    queryKey: ['overview', 'history', hours],
    queryFn: () => overviewApi.getHistory(hours),
    refetchInterval: 5 * 60_000,
    staleTime: 2 * 60_000,
  });
}
